exports.hostName = "https://shimp.dev";
